var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStatusTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000610352,
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 5.65234C14.8281 5.65234 16.2499 7.04688 16.2499 8.79688C16.2499 10 15.5663 11.0938 14.4999 11.6406L12.3124 12.9258V13.5C12.3124 13.9922 11.9023 14.375 11.4374 14.375C10.9453 14.375 10.5624 13.9922 10.5624 13.5V12.4062C10.5624 12.1055 10.6992 11.832 10.9726 11.668L13.6523 10.1094C14.1992 9.83594 14.4999 9.34375 14.4999 8.79688C14.4999 8.03125 13.8437 7.40234 13.0781 7.40234H10.1249C9.63275 7.40234 9.24994 7.78516 9.24994 8.27734C9.24994 8.71484 8.83978 9.125 8.37494 9.125C7.88275 9.125 7.49994 8.74219 7.49994 8.27734C7.49994 6.82812 8.67572 5.65234 10.1249 5.65234H13.0781ZM11.4374 15.6875C12.039 15.6875 12.5312 16.207 12.5312 16.7812C12.5312 17.3828 12.039 17.875 11.4374 17.875C10.8085 17.875 10.3437 17.4102 10.3437 16.7812C10.3437 16.1797 10.8085 15.6875 11.4374 15.6875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusTodo);
export default __webpack_public_path__ + "static/media/icon-status-todo.c25022c36eaab2af41cbf29d76517647.svg";
export { ForwardRef as ReactComponent };